export default (list) => {
	if (list.length === 0) return true;
	let numOfContacts = 0;
	list.forEach((entity) => (numOfContacts += entity?.contacts?.length));
	if (numOfContacts === 0) return true;
	return false;
};
